// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1QGbw","box":"WorkspacesBox_box__2VpLB","node":"WorkspacesBox_node__1en0D"};